import Vue from 'vue';
import Vuex from 'vuex';

import login from './login/index';
import userModel from './user/index'
import app from './app/index';
import codeStore from './admin/codeStore/index';
import codeStoreExtended from './admin/codeStoreExtended/index';
import codeStoreSimple from './admin/codeStoreSimple/index';
import companySite from './admin/companySite/index'
import logins from './admin/logins/index';
import user from './admin/user/index'
import userEdit from './admin/userEdit/index'
import emailTemplateEditor from './admin/emailTemplateEditor/index';
import patient from './medici/patient/index';
import appointmentHistory from './medici/appointmentHistory/index'
import appointmentManDocError from './medici/appointmentManDocError/index'
import stock from './medici/stock/index'
import doctorDailyAttendance from './medici/doctorDailyAttendance/index'
import monthlyPremiumForDoctors from './medici/report/monthlyPremiumForDoctors/index'
import patientTrafficPerTreatment from './medici/report/patientTrafficPerTreatment/index'
import patientTrafficPerDoctor from './medici/report/patientTrafficPerDoctor/index'
import doctorTemplate from './medici/doctorTemplate/index'
import bno from './medici/bno/index'
import drug from './medici/drug/index'
import drugBno from './medici/drug/drugBno/index'
import drugEquiv from './medici/drug/drugEquiv/index'
import drugStrain from './medici/drugStrain/index'
import feuImport from './medici/xlsLoaderFeuImport/index'
import patientAttendanceAppointment from './medici/patientAttendance/appointment/index'
import eprofileAktGyogy from './medici/patient/eprofile/aktGyogy/index'
import eprofileAktProblemak from './medici/patient/eprofile/aktProblemak/index'
import eprofileAllergia from './medici/patient/eprofile/allergia/index'
import eprofileAutonomia from './medici/patient/eprofile/autonomia/index'
import eprofileEletmod from './medici/patient/eprofile/eletmod/index'
import eprofileImplantatum from './medici/patient/eprofile/implantatum/index'
import eprofileKorabbiMutet from './medici/patient/eprofile/korabbiMutet/index'
import eprofileLezartProblemak from './medici/patient/eprofile/lezartProblemak/index'
import eprofileNemAllergia from './medici/patient/eprofile/nemAllergia/index'
import eprofileTerapia from './medici/patient/eprofile/terapia/index'
import eprofileTerhesseg from './medici/patient/eprofile/terhesseg/index'
import eprofileVedooltasok from './medici/patient/eprofile/vedooltasok/index'
import eprofileVercsoport from './medici/patient/eprofile/vercsoport/index'
import eRecept from './medici/patient/erecept/index'
import bnoArchive from './medici/drugStrainArchive/bnoArchive/index'
import drugBnoArchive from './medici/drugStrainArchive/drugArchive/drugBnoArchive/index'
import drugEquivArchive from './medici/drugStrainArchive/drugArchive/drugEquivArchive/index'
import drugArchive from './medici/drugStrainArchive/drugArchive/index'
import doctorConsultConfig from './medici/doctorConsultConfig/index'
import patientWaiting from './medici/patientWaiting/index'
import eesztLogins from './medici/eesztLogins/index'
import labHandle from './medici/labHandle/index'
import eesztLog from './medici/eesztLog/index'
import patientHistory from './medici/patientHistory/index'
import labHandleHistory from './medici/labHandleHistory/index'
import patientEvidenceHistory from './medici/patientEvidenceHistory/index'
import appointmentModal from './medici/appointments/appointmentModal/index'
import appointment from './medici/appointments/index'
import appointmentInpatientModal from './medici/appointmentsInpatient/appointmentInpatientModal/index'
import appointmentInpatient from './medici/appointmentsInpatient/index'
import staff from './medici/staff/index'
import humanResource from './medici/humanResource/index'
import treatmentType from './medici/treatmentType/index'
import room from './medici/room/index'
import instrument from './medici/instrument/index'
import doctor from './medici/doctor/index'
import role from './admin/role/index'
import company from './admin/company/index'
import documentLog from './medici/documentLog/index'
import ekatalogus from './medici/patient/ekatalogus/index'
import ehr from './medici/patient/ehr/index'
import ebeutalo from './medici/patient/ebeutalo/index'
import countryCountyCity from './admin/countryCountyCity/index'
import patientHealthCard from './medici/patient/healthCard/index'
import periodicAptitudeTest from './medici/patient/periodicAptitudeTest/index'
import generalDocumentTemplate from './medici/generalDocumentTemplate/index'
import patientOperations from './medici/patient/operations/index'
import treatmentCount from './medici/report/treatmentCount/index'
import plea from './gdpr/plea/index'
import gdprPerson from './gdpr/gdprPerson/index'
import dataAssetInventory from './gdpr/dataAssetInventory/index'
import incidentRegistration from './gdpr/incidentRegistration/index'
import eventRegistration from './gdpr/eventRegistration/index'
import dataTransferEvent from './gdpr/dataTransferEvent/index'
import impactAssessmentDataHandling from './gdpr/impactAssessmentDataHandling/index'
import impactAssessment from './gdpr/impactAssessment/index'
import dataManagementProcessPlace from './gdpr/dataManagementProcessPlace/index'
import dataManagementProcess from './gdpr/dataManagementProcess/index'
import drugSelectDialog from './medici/drugSelectDialog/index'
import specialistRecommendation from './medici/specialistRecommendation'
import pubHealthCareCert from './medici/publicHealthCareCertification'
import eesztResend from './medici/eesztResend/index'
import bnoSelectDialog from './medici/bnoSelectDialog/index'
import organizationUnit from './admin/organizationUnit/index'
import doctorMagisTemplate from './medici/doctorMagisTemplate/index'
import myReservations from './medici/myReservations/index'
import backofficeInvoiceList from './backoffice/invoiceList/index'
import invoiceTreatment from './backoffice/invoiceTreatment/index'
import occupationHealthPartner from './medici/occupationHealthAdmin/partner/index'
import occupationHealthEmployee from './medici/occupationHealthAdmin/occupationHealthEmployee/index'
import employabilityOpinion from './medici/occupationHealthRiport/employabilityOpinion/index'
import employability from './medici/occupationHealthRiport/employability/index'
import finalExamination from './medici/occupationHealthRiport/finalExamination/index'
import finalExaminationResult from './medici/occupationHealthRiport/finalExaminationResult/index'
import medicalRecordSheet from './medici/occupationHealthRiport/medicalRecordSheet/index'
import occupationHealthReport from './medici/report/occupationHealthReport/index'
import occupationHealthReportConfig from './medici/report/occupationHealthReport/occupationHealthReportConfig/index'
import occupationHealthRestriction from './medici/occupationHealthAdmin/restriction/index'
import occupationHealthVaccination from './medici/occupationHealthAdmin/vaccination/index'
import occupationHealthExposure from './medici/occupationHealthAdmin/exposure/index'
import occupationHealthCodeStore from './medici/occupationHealthAdmin/occupationHealthCodeStore/index'
import occupationHealthReferral from './medici/occupationHealthAdmin/referral/index'
import additionalExamination from './medici/additionalExamination/index'
import occupationHealthFirearmPermit from './medici/occupationHealthOfficialPermit/firearmPermit/index'
import occupationHealthDriverLicense from './medici/occupationHealthOfficialPermit/driverLicense/index'
import employabilityReport from './medici/occupationHealthRiport/employabilityReport/index'
import vaccinationReport from './medici/occupationHealthRiport/vaccinationReport/index'
import occupationHealthlabReport from './medici/occupationHealthRiport/occupationHealthlabReport/index'
import insurancePartner from './backoffice/insurancePartner/index'
import discounts from './backoffice/discounts/index'
import insurancePartners from './backoffice/insurancePartners/index'
import employabilityDoctorTemplate from './medici/occupationHealthAdmin/employabilityDoctorTemplate/index'
import licenceManagement from './admin/licenceManagement/index'
import log from './admin/log/index'
import eDoc from './medici/patient/eDoc/index'
import emailView from './admin/emails/index'
import covidRAT from './medici/covidRAT/index'
import patientEvidenceWithoutEesztId from './medici/eesztReport/patientEvidenceWithoutEesztId/index'
import eesztPuphax from './medici/eesztPuphax/index'
import drugPuphax from './medici/drugPuphax/index'
import eesztPostSubmission from './medici/eesztPostSubmission/index'
import appointmentStatus from './medici/appointmentStatus/index'
import treatmentStatisticCount from './medici/report/treatmentStatisticCount/index'
import treatmentStatisticReferral from './medici/report/treatmentStatisticReferral/index'
import treatmentStatisticMedio from './medici/report/treatmentStatisticMedio/index'
import drugSelect from './medici/drugSelect/index'
import drugSelectDialogV2 from './medici/drugSelectDialogV2/index'
import simpleImport from './medici/xlsLoaderSimpleImport/index'
import utilityImport from './medici/xlsLoaderUtilityImport/index'
import cancelledAppointments from './medici/cancelledAppointments/index'
import healthPartnerManagerReport from './medici/occupationHealthRiport/healthPartnerManagerReport/index'
import occupationHealthEmployabilityReport from './medici/occupationHealthRiport/occupationHealthEmpolyabilityReport/index';
import feuTreatmentReport from './medici/occupationHealthRiport/feuTreatmentReport/index';
import dailyPatientTraffic from './admin/dailyPatientTraffic/index.js'
import weeklyPatientTraffic from './admin/weeklyPatientTraffic/index.js'
import worklistDeliveryNote from './medici/report/worklistDeliveryNote/index.js'
import pregnancy from './medici/pregnancy/index.js'
import patientVaccination from './medici/patient/patientVaccination/index.js'
import illnessSelectDialog from './medici/illnessSelectDialog/index.js'
import medicationSelectDialog from './medici/medicationSelectDialog/index.js'
import medicationSelectSingleDialog from './medici/medicationSelectSingleDialog/index.js'
import occupationalHealthPartner from './medici/occupationHealthAdmin/occupationalHealthPartner/index.js'
import packages from './backoffice/packages/index.js'
import contracts from './backoffice/contracts/index.js'
import packagesSelectDialog from './medici/packagesSelectDialog/index.js'
import restrictionSelectDialog from './medici/restrictionSelectDialog/index.js'
import sapRiports from './admin/sapRiports';
import allEesztReport from './medici/eesztReport/allEesztReport/index.js'
import priceList from './backoffice/priceList';
import laboratoryTypesPriceList from './backoffice/laboratoryTypesPriceList';
import basicCustomerList from './backoffice/basicCustomerList/index.js'
import treatmentSelectDialog from './medici/treatmentSelectDialog/index.js'
import proformaInvoice from './backoffice/proformaInvoice/index.js'
import otherBillableItems from './backoffice/otherBillableItems';
import codedOtherBillableItems from './backoffice/codedOtherBillableItems';
import treatmentSelectSingleDialog from './medici/treatmentSelectSingleDialog/index.js';
import laboratoryTypes from './medici/laboratoryTypes/index.js';
import selectLaboratoryTypesDialog from './medici/selectLaboratoryTypesDialog/index.js';
import supervisors from './medici/occupationHealthAdmin/supervisors';
import deletablePackages from './backoffice/deletablePackages/index.js';
import dashboard from './dashboard/index.js';
import documentHistory from './medici/documentHistory/index.js';
import patientEvidenceNonValidatedDocuments from './medici/patientEvidenceNonValidatedDocuments/index.js';
import employabilityNonValidatedDocuments from './medici/employabilityNonValidatedDocuments/index.js';
import employabilitySickness from './medici/occupationHealthRiport/employabilitySickness/index.js';
import employabilitySicknessNonValidatedDocuments from './medici/employabilitySicknessNonValidatedDocuments/index.js';
import mergingPatients from './medici/mergingPatients/index.js';
import medioLog from './medici/medioLog/index.js';
import feuEmployabilityImport from './medici/xlsLoaderFeuEmployabilityImport/index.js'
import feuPartnerHierarchyImport from './medici/xlsLoaderFeuPartnerHierarchyImport/index.js'
import feuEmployeeIdImport from './medici/xlsLoaderFeuEmployeeIdImport/index.js'
import patientInternalReferral from './medici/patient/patientInternalReferral/index.js'
import appointmentReferralModal from './medici/patient/appointmentReferralModal/index.js'
import conflictingLabTests from './medici/conflictingLabTests/index.js'
import synlabPriceListImport from './medici/synlabPriceListImport/index.js';
import machineOperatorPermit from './medici/occupationHealthOfficialPermit/machineOperatorPermit/index.js';
import feuSupervisorImport from './medici/xlsLoaderFeuSupervisorImport/index.js'
import deviceAndRoomAssignment from './medici/deviceAndRoomAssignment/index.js'
import healthInsurancePartner from './medici/healthInsurancePartner/index.js'
import otherExaminationDocumentType from './medici/otherExaminationDocumentType/index.js'
import doctorUtilization from './medici/report/doctorUtilization/index.js'
import roomUtilizationReport from './medici/report/roomUtilizationReport/index.js'

Vue.use(Vuex);

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules: {
        app,
        userModel,
        login,
        codeStore,
        codeStoreExtended,
        codeStoreSimple,
        companySite,
        logins,
        user,
        userEdit,
        emailTemplateEditor,
        employabilitySickness,
        appointmentHistory,
        appointmentManDocError,
        appointment,
        appointmentInpatient,
        stock,
        patient,
        doctorDailyAttendance,
        monthlyPremiumForDoctors,
        patientTrafficPerTreatment,
        patientTrafficPerDoctor,
        doctorTemplate,
        bno,
        drug,
        drugBno,
        drugEquiv,
        drugStrain,
        patientAttendanceAppointment,
        eprofileAktGyogy,
        eprofileAktProblemak,
        eprofileAllergia,
        eprofileAutonomia,
        eprofileEletmod,
        eprofileImplantatum,
        eprofileKorabbiMutet,
        eprofileLezartProblemak,
        eprofileNemAllergia,
        eprofileTerapia,
        eprofileTerhesseg,
        eprofileVedooltasok,
        eprofileVercsoport,
        eRecept,
        ekatalogus,
        ehr,
        ebeutalo,
        bnoArchive,
        drugBnoArchive,
        drugEquivArchive,
        drugArchive,
        discounts,
        doctorConsultConfig,
        patientWaiting,
        eesztLogins,
        labHandle,
        eesztLog,
        patientHistory,
        appointmentModal,
        appointmentInpatientModal,
        labHandleHistory,
        patientEvidenceHistory,
        staff,
        humanResource,
        treatmentType,
        room,
        instrument,
        doctor,
        role,
        company,
        documentLog,
        countryCountyCity,
        patientHealthCard,
        periodicAptitudeTest,
        generalDocumentTemplate,
        patientOperations,
        proformaInvoice,
        treatmentCount,
        plea,
        gdprPerson,
        dataAssetInventory,
        incidentRegistration,
        eventRegistration,
        dataTransferEvent,
        impactAssessmentDataHandling,
        impactAssessment,
        dataManagementProcessPlace,
        dataManagementProcess,
        drugSelectDialog,
        specialistRecommendation,
        pubHealthCareCert,
        eesztResend,
        bnoSelectDialog,
        organizationUnit,
        doctorMagisTemplate,
        myReservations,
        occupationHealthPartner,
        employabilityOpinion,
        employability,
        finalExamination,
        medicalRecordSheet,
        occupationHealthReport,
        occupationHealthReportConfig,
        occupationHealthRestriction,
        occupationHealthVaccination,
        occupationHealthExposure,
        occupationHealthCodeStore,
        occupationHealthReferral,
        additionalExamination,
        occupationHealthFirearmPermit,
        occupationHealthDriverLicense,
        employabilityReport,
        vaccinationReport,
        backofficeInvoiceList,
        invoiceTreatment,
        insurancePartner,
        occupationHealthlabReport,
        employabilityDoctorTemplate,
        licenceManagement,
        log,
        eDoc,
        emailView,
        covidRAT,
        patientEvidenceWithoutEesztId,
        eesztPuphax,
        drugPuphax,
        eesztPostSubmission,
        appointmentStatus,
        feuImport,
        treatmentStatisticCount,
        treatmentStatisticReferral,
        treatmentStatisticMedio,
        drugSelectDialogV2,
        simpleImport,
        utilityImport,
        cancelledAppointments,
        healthPartnerManagerReport,
        occupationHealthEmployabilityReport,
        feuTreatmentReport,
        dailyPatientTraffic,
        weeklyPatientTraffic,
        worklistDeliveryNote,
        finalExaminationResult,
        pregnancy,
        patientVaccination,
        illnessSelectDialog,
        medicationSelectDialog,
        medicationSelectSingleDialog,
        occupationalHealthPartner,
        packages,
        insurancePartners,
        contracts,
        packagesSelectDialog,
        restrictionSelectDialog,
        sapRiports,
        allEesztReport,
        basicCustomerList,
        treatmentSelectDialog,
        priceList,
        otherBillableItems,
        codedOtherBillableItems,
        treatmentSelectSingleDialog,
        deletablePackages,
        selectLaboratoryTypesDialog,
        laboratoryTypesPriceList,
        laboratoryTypes,
        dashboard,
        supervisors,
        documentHistory,
        patientEvidenceNonValidatedDocuments,
        employabilityNonValidatedDocuments,
        employabilitySicknessNonValidatedDocuments,
        occupationHealthEmployee,
        mergingPatients,
        drugSelect,
        medioLog,
        feuEmployabilityImport,
        feuPartnerHierarchyImport,
        feuEmployeeIdImport,
        patientInternalReferral,
        appointmentReferralModal,
        conflictingLabTests,
        synlabPriceListImport,
        machineOperatorPermit,
        feuSupervisorImport,
        deviceAndRoomAssignment,
        healthInsurancePartner,
        otherExaminationDocumentType,
        doctorUtilization,
        roomUtilizationReport
    }
})
